import { useParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { NodeTerminal } from '../Nodes/NodeTerminal/NodeTerminal';
import { NodeAPI } from '../Nodes/NodeAPI/NodeAPI';
import { NodeParser } from '../Nodes/NodeParser/NodeParser';
import { NodeSets } from '../Nodes/NodeSets/NodeSets';
import { NodeAutomation } from '../Nodes/NodeAutomation/NodeAutomation';
import { NodeJenkins } from '../Nodes/NodeJenkins/NodeJenkins';
import { NodeSecurity } from '../Nodes/NodeSecurity/NodeSecurity';
import { NodeSQL } from '../Nodes/NodeSQL/NodeSQL';
import NodeEditorTerminal from '../Nodes/NodeEditorTerminal/NodeEditorTerminal';
import { SecurityTraining } from 'views/Training/SecurityTraining/SecurityTraining';
import { NodeJupyter } from '../Nodes/NodeJupyter/NodeJupyter';
import { NodeCTD } from '../Nodes/NodeCTD/NodeCTD';
import NodeIDE from 'views/CodeEditor/views/NodeIDE';
import { useAPI } from 'components/lib';
import { decoder } from 'utils/helpers/decoder';
import { useState } from 'react';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import { NodeJSONata } from '../Nodes/NodeJSONata/NodeJSONata';

export function NodeRouter(props) {
    const Event = require('components/lib').Event;
    const { lab_id, node_id, job_id, resource } = useParams();
    const navigate = useNavigate();
    const [nodeData, setNodeData] = useState(null);
    const [viewName, setViewName] = useState('')

    const { data, loading } = useAPI(`/api/labs/${lab_id}/nodes/${node_id}/${resource}`, 'GET')

    useEffect(() => {
        if (data) {
            const jsonData = decoder(data);
            setNodeData(jsonData)
            if (jsonData?.resource?.config?.view) {
                setViewName(jsonData?.resource?.config?.view)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    const VIEW_MAP = {
        NodeTerminal,
        NodeAPI,
        NodeParser,
        NodeSets,
        NodeAutomation,
        NodeJenkins,
        NodeSecurity,
        NodeSQL,
        NodeEditorTerminal,
        SecurityTraining,
        NodeJupyter,
        NodeCTD,
        NodeIDE,
        NodeJSONata
    }

    const isLiveAssessment = job_id ? true : false;

    // Trigger an event once
    useEffect(() => {
        if (viewName) {
            Event('labs_started');
            // Trigger 'containers_spun' event when the resource is 'terminal', 'linux_advanced', 'deploy_1', 'deploy_2', 'jenkins'
            if (nodeData?.resource?.config?.containerConfig) {
                Event('containers_spun');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nodeData]);

    if (loading || !nodeData) {
        return <LoadingBackdrop isOpen={loading} />;
    }


    const View = viewName ? VIEW_MAP[viewName] : null;

    if (!viewName || !View) {
        // Immediately navigate if viewName is provided but not in map
        navigate('/notfound');
        return null; // Prevent further rendering
    }

    if (View && viewName === 'NodeAutomation') {
        return <View {...props} nodeData={nodeData} loading={loading} live_assessment={isLiveAssessment} />;
    }
    if (View) {
        return <View {...props} nodeData={nodeData} loading={loading} />;
    }

    return null;
}
